/**
 * PDP + produto em destaque: variant, imageSlider, mainPage, zoom PhotoSwipe (theme.photoSwipe).
 * Depende de product.js (theme.product, teamdropProductFormProto, quantityInput).
 * theme-script (window.icons) para setas/fechar no lightbox.
 */
if (!window.teamdropProductPdpAttached) {
  window.teamdropProductPdpAttached = true;

  if (theme && theme.product) {
    (theme.product.variant = {
      productVariant: null,
      imageSlider: null,
      form: null,
      selectedVariant: null,
      selectedOptions: null,
      availableVariant: null,
      variantData: null,
      updateUrlOnVariantChanged: !1,
      sections: null,
      render: function () {
        if (this.productVariant) {
          let e = this;
          (this.productUrl = this.productVariant.dataset.url),
            (this.sectionId = this.productVariant.dataset.section),
            (this.optionStyle = this.productVariant.dataset.style),
            (this.firstOptionContainer = this.productVariant.querySelector(
              '.product-variant__option[data-option-index="1"]'
            )),
            (this.optionContainer = this.productVariant.querySelectorAll(
              ".product-variant__option"
            )),
            this.firstOptionContainer &&
            ("swatches" === this.optionStyle
              ? ((this.options = this.productVariant.querySelectorAll(
                'input[type="radio"]'
              )),
                this.firstOptionContainer
                  .querySelectorAll('input[type="radio"]')
                  .forEach((t) => {
                    t.addEventListener(
                      "change",
                      e.handleFirstOptionChange.bind(e)
                    );
                    let i = e.productVariant.querySelector(
                      `label[for="${t.getAttribute("id")}"]`
                    );
                    i.classList.contains("label--tag") ||
                      ((t = i.dataset.swatch.toLowerCase()),
                        (t = theme.product.customSwatchColors()[t]) &&
                        (i.style.cssText = "--swatch-background-color: " + t));
                  }),
                this.optionContainer.forEach((t) => {
                  t.querySelectorAll('input[type="radio"]').forEach((t) => {
                    t.addEventListener("change", e.handleVariantChange.bind(e));
                  });
                }))
              : ((this.options =
                this.productVariant.querySelectorAll("select")),
                this.firstOptionContainer
                  .querySelector("select")
                  .addEventListener(
                    "change",
                    e.handleFirstOptionChange.bind(e)
                  ),
                this.options.forEach((t) => {
                  t.addEventListener("change", e.handleVariantChange.bind(e));
                })),
              (this.selectedOptions = this.getSelectedOptions()),
              (this.selectedVariant = this.getSelectedVariantData(
                this.selectedOptions
              )),
              (this.availableVariant =
                "swatches" === this.optionStyle
                  ? this.getAvailableVariant(
                    this.firstOptionContainer.querySelector("input:checked")
                  )
                  : this.getAvailableVariant(
                    this.firstOptionContainer.querySelector("select")
                  )),
              this.setAvailableOption(),
              this.getAvailableFirstOptions());
        }
      },
      handleFirstOptionChange: function (e) {
        (this.availableVariant = this.getAvailableVariant(e.target)),
          this.setAvailableOption();
      },
      handleVariantChange: function (e) {
        if (
          ((this.selectedOptions = this.getSelectedOptions()),
            (this.selectedVariant = this.getSelectedVariantData(
              this.selectedOptions
            )),
            this.updateMedia(),
            this.selectedVariant && this.selectedVariant.available
              ? (this.updateVariantInput(),
                this.updateUrlOnVariantChanged && this.updateURL(),
                this.renderProductInfo(),
                this.form && this.form.enableBuyButton(),
                this.updateAllProductVariantElement(
                  e.target.closest(
                    `.product-variant[data-section="${this.sectionId}"]`
                  )
                ))
              : this.form && this.form.disableBuyButton(),
            "swatches" === this.optionStyle)
        ) {
          let t = e.target;
          t
            .closest(".product-variant__option")
            .querySelector(".selected-option-variant").innerHTML = t.value;
        }
      },
      getAvailableVariant: function (e) {
        return this.getVariantData().filter((t) => t.option1 === e.value);
      },
      setAvailableOption: function () {
        let e = this.availableVariant;
        "swatches" === this.optionStyle
          ? Array.from(this.optionContainer)
            .slice(1)
            .forEach((t, i) => {
              t.querySelectorAll('input[type="radio"]').forEach((t) => {
                0 ===
                  e.filter((e) => e.options[i + 1] === t.value && e.available)
                    .length
                  ? t.classList.add("product-variant__input--unavailable")
                  : t.classList.remove("product-variant__input--unavailable");
              });
            })
          : Array.from(this.options)
            .slice(1)
            .forEach((t, i) => {
              t.querySelectorAll("option").forEach((t) => {
                0 ===
                  e.filter((e) => e.options[i + 1] === t.value && e.available)
                    .length
                  ? t.setAttribute("disabled", !0)
                  : t.removeAttribute("disabled");
              });
            });
      },
      getSelectedOptions: function () {
        return "swatches" === this.optionStyle
          ? Array.from(this.options)
            .filter((e) => e.checked)
            .map((e) => e.value)
          : Array.from(this.productVariant.querySelectorAll("select")).map(
            (e) => e.value
          );
      },
      getSelectedVariantData: function (e) {
        return this.getVariantData().find(
          (t) => !t.options.map((t, i) => e[i] === t).includes(!1)
        );
      },
      getAvailableFirstOptions: function () {
        1 < this.optionContainer.length ||
          (1 === this.optionContainer.length &&
            ("swatches" === this.optionStyle
              ? this.optionContainer[0]
                .querySelectorAll('input[type="radio"]')
                .forEach((e) => {
                  this.getVariantData().find(
                    (t) => t.option1 === e.value && t.available
                  )
                    ? e.classList.remove("product-variant__input--unavailable")
                    : e.classList.add("product-variant__input--unavailable");
                })
              : this.optionContainer[0]
                .querySelectorAll("option")
                .forEach((e) => {
                  this.getVariantData().find(
                    (t) => t.option1 === e.value && t.available
                  )
                    ? e.removeAttribute("disabled")
                    : e.setAttribute("disabled", !0);
                })));
      },
      updateURL: function () {
        this.selectedVariant &&
          !1 !== this.productVariant.dataset.updateUrl &&
          window.history.replaceState(
            {},
            "",
            this.productUrl + "?variant=" + this.selectedVariant.id
          );
      },
      updateMedia: function () {
        var e;
        this.selectedVariant &&
          this.selectedVariant.featured_media &&
          (e = document.querySelector(
            `[data-media-id="${this.sectionId}-${this.selectedVariant.featured_media.id}"]`
          )) &&
          this.imageSlider &&
          ((e = parseInt(e.dataset.index)),
            this.imageSlider.slideToLoop(parseInt(e), 600));
      },
      updateVariantInput: function () {
        let e = this;
        document
          .querySelectorAll("#product-form-" + this.sectionId)
          .forEach((t) => {
            let i = t.querySelector('input[name="id"]');
            (i.value = e.selectedVariant.id),
              i.dispatchEvent(new Event("change", { bubbles: !0 }));
          });
      },
      renderStickyFormVariant: function () {
        (this.productUrl = this.productVariant.dataset.url),
          (this.productId = this.productVariant.dataset.productId),
          (this.sectionId = this.productVariant.dataset.section);
        let e = this.productVariant.querySelector(".product-variant__select"),
          t = this.getVariantData();
        e.querySelectorAll("option").forEach((e) => {
          t.find((t) => t.id === parseInt(e.value) && t.available)
            ? e.removeAttribute("disabled")
            : e.setAttribute("disabled", !0);
        }),
          e.addEventListener(
            "change",
            this.handleStickyFormVariantChange.bind(this)
          );
      },
      handleStickyFormVariantChange: function (e) {
        let t = parseInt(e.target.value);
        (this.selectedVariant = this.getVariantData().find((e) => e.id === t)),
          this.selectedVariant && this.selectedVariant.available
            ? (this.updateVariantInput(),
              this.updateUrlOnVariantChanged && this.updateURL(),
              this.renderProductInfo(),
              this.form && this.form.enableBuyButton(),
              this.updateAllProductVariantElement(
                e.target.closest(
                  `.product-variant[data-section="${this.sectionId}"]`
                )
              ))
            : this.form && this.form.disableBuyButton();
      },
      updateAllProductVariantElement: function (e) {
        let t = document.querySelectorAll(
          `.product-variant[data-section="${this.sectionId}"]`
        ),
          i = this;
        t.forEach((t) => {
          t != e &&
            ("swatches" === t.dataset.style
              ? t.querySelectorAll(".product-variant__inputs").forEach((e, t) => {
                e.querySelectorAll('input[type="radio"]').forEach((e) => {
                  e.value === i.selectedVariant.options[t]
                    ? (e.checked = !0)
                    : (e.checked = !1);
                });
              })
              : t.querySelectorAll("select").forEach((e, t) => {
                Array.from(e.querySelectorAll("option"))
                  .map((e) => parseInt(e.value))
                  .includes(i.selectedVariant.id)
                  ? (e.value = i.selectedVariant.id)
                  : (e.value = i.selectedVariant.options[t]);
              }));
        });
      },
      renderProductInfo: function () {
        let e = this;
        var t = this.sections.map((e) => e.sectionId).join(",");
        fetch(
          `${this.productUrl}?variant=${this.selectedVariant.id}&sections=` + t
        )
          .then((e) => e.json())
          .then((t) => {
            e.sections.forEach((e) => {
              let i = new DOMParser().parseFromString(
                t[e.sectionId],
                "text/html"
              );
              e.selectors.forEach((e) => {
                let t = document.querySelector(e),
                  n = i.querySelector(e);
                t && n && (t.innerHTML = n.innerHTML);
              });
            });
          });
      },
      getVariantData: function () {
        return (
          (this.variantData =
            this.variantData ||
            JSON.parse(
              this.productVariant.querySelector('[type="application/json"]')
                .textContent
            )),
          this.variantData
        );
      },
    }),
      (theme.product.imageSlider = {
        sliderSelector: void 0,
        sliderNavSelector: void 0,
        productId: void 0,
        sectionId: void 0,
        render: function () {
          if (
            ((this.sliders = document.querySelector(this.sliderSelector)),
              this.sliders)
          ) {
            var t = this.sliders.closest("product-gallery-swiper");
            if (t) {
              if (!t.mainSwiper && typeof t.initOnce === "function") t.initOnce();
              return t.mainSwiper || void 0;
            }
          }
        },
      }),
      (theme.product.mainPage = {
        mainSwiperSelector: ".product-media__swiper",
        navSwiperSelector: ".product-media__nav-swiper",
        render: function (scopeRoot) {
          var roots,
            self = this;
          if (scopeRoot && scopeRoot.nodeType === 1) {
            roots = scopeRoot.querySelectorAll(".product-detail");
          } else {
            roots = document.querySelectorAll(
              ".main-product .product-detail, .featured-product .product-detail"
            );
          }
          roots.forEach(function (mainProduct) {
            self.renderOne(mainProduct);
          });
        },
        renderOne: function (mainProduct) {
          if (!mainProduct || mainProduct.dataset.teamdropMainPageInit === "true")
            return;
          var formEl = mainProduct.querySelector(".product-form");
          if (!formEl) return;
          var mpId = mainProduct.getAttribute("id"),
            t,
            i = Object.create(teamdropProductFormProto);
          if (mainProduct.querySelector(".product-media__swiper") && mpId) {
            let e = Object.create(theme.product.imageSlider);
            (e.sliderSelector = "#" + mpId + " " + this.mainSwiperSelector),
              (e.sliderNavSelector =
                "#" + mpId + " " + this.navSwiperSelector),
              (e.productId = mainProduct.dataset.productId),
              (e.sectionId = mainProduct.dataset.sectionId),
              (t = e.render()),
              this.setMediaContainerHeight(mainProduct),
              window.addEventListener("resize", function () {
                theme.product.mainPage.setMediaContainerHeight(mainProduct);
              });
          }
          (i.form = formEl), i.render();
          var n = [
              "#price-" + mainProduct.dataset.sectionId,
              "#stock-" + mainProduct.dataset.sectionId,
            ],
            r =
              mainProduct.closest(".main-product") &&
              document.querySelector(".product-sticky")
                ? document.querySelector(".product-sticky")
                : null;
          if (r) {
            this.renderStickyForm(r, mainProduct),
              n.push(".product-sticky .js-contents");
            var stickyQty = r.querySelector(".product-quantity");
            if (stickyQty) {
              let s = Object.create(theme.product.quantityInput);
              (s.element = stickyQty), s.render();
            }
          }
          var sectionsPayload = [
            { sectionId: mainProduct.dataset.sectionId, selectors: n },
          ];
          let a = Object.create(theme.product.variant);
          if (
            ((a.productVariant =
              mainProduct.querySelector(".product-variant")),
              (a.imageSlider = t),
              (a.form = i),
              (a.updateUrlOnVariantChanged = !0),
              (a.sections = sectionsPayload),
              a.render(),
              r)
          ) {
            let c = Object.create(teamdropProductFormProto);
            if (
              ((c.form = r.querySelector(".product-form")),
                (c.handleError = function (e = !1) {
                  theme.notification.error(window.cartStrings.cannotUpdateCart, e);
                }),
                c.render(),
                r.querySelector(".product-variant"))
            ) {
              let l = Object.create(theme.product.variant);
              (l.productVariant = r.querySelector(".product-variant")),
                (l.sections = sectionsPayload),
                (l.form = c),
                (l.updateUrlOnVariantChanged = !0),
                l.renderStickyFormVariant();
            }
          }
          var buyBtns = mainProduct.querySelector(".product-detail__buy-buttons");
          if (buyBtns) {
            let d = Object.create(theme.product.quantityInput);
            (d.wrapper = buyBtns), d.render();
          }
          var fpWrap = mainProduct.closest(".featured-product");
          if (fpWrap) {
            let fq = fpWrap.querySelector(".featured-product__quantity");
            if (fq) {
              let qIn = Object.create(theme.product.quantityInput);
              (qIn.wrapper = fq), qIn.render();
            }
          }
          if ("true" === mainProduct.dataset.enabledZoom) {
            const zoomButton = mainProduct.querySelector(".product-button__zoom");
            if (zoomButton) {
              zoomButton.addEventListener("click", function (e) {
                e.preventDefault();
                let photoSwipeContainer = mainProduct;
                if (!window.PhotoSwipe) {
                  let photoSwipe = Object.create(theme.photoSwipe);
                  photoSwipe.init(photoSwipeContainer);
                  let checkLoaded = function () {
                    if (window.PhotoSwipe) {
                      let activeSlide = mainProduct.querySelector(
                          ".swiper-slide-active"
                        ),
                        activeIndex = activeSlide
                          ? parseInt(activeSlide.dataset.index)
                          : 0;
                      photoSwipe.openGallery(activeIndex);
                    } else setTimeout(checkLoaded, 50);
                  };
                  checkLoaded();
                } else {
                  let photoSwipe = Object.create(theme.photoSwipe);
                  (photoSwipe.container = photoSwipeContainer),
                    photoSwipe.openGallery(
                      (function () {
                        let activeSlide = mainProduct.querySelector(
                          ".swiper-slide-active"
                        );
                        return activeSlide ? parseInt(activeSlide.dataset.index) : 0;
                      })()
                    );
                }
              });
            }
          }
          this.addRecentViewProduct(mainProduct),
            (mainProduct.dataset.teamdropMainPageInit = "true");
        },
        setSlider: function () { },
        renderStickyForm: function (e, mainProduct) {
          let t = mainProduct.querySelector(".product-form");
          window.teamdropOnScrollHub.callbacks.push(
            theme.utilities.debounce(function () {
              t.getBoundingClientRect().top < 0
                ? e.classList.remove("translate-y-b-hidden")
                : e.classList.add("translate-y-b-hidden");
            }, 300)
          );
        },
        setMediaContainerHeight: function (mainProduct) {
          if (!mainProduct) return;
          let e = mainProduct.querySelector(".product-media"),
            t = e && e.querySelector(".thumbnail-left, .thumbnail-right");
          if (t && e) {
            let i = e.querySelector(".product-media__swiper");
            if (i) {
              let mediaElement = i.querySelector(".media"),
                stickyElement = e.querySelector(".product-media-sticky"),
                paddingOffset = 0;
              if (stickyElement) {
                let computedStyle = window.getComputedStyle(stickyElement),
                  paddingTop = parseFloat(computedStyle.paddingTop) || 0,
                  paddingBottom = parseFloat(computedStyle.paddingBottom) || 0;
                paddingOffset = paddingTop + paddingBottom;
              }
              mediaElement &&
                (t.style.height =
                  mediaElement.offsetHeight + paddingOffset + "px");
            }
          }
        },
        addRecentViewProduct: function (mainProduct) {
          if (!mainProduct || !mainProduct.closest(".main-product")) return;
          var e = mainProduct.dataset.productId;
          let t = theme.utilities.getListFromStorage(
            theme.storageKeys.recentViewedProduct
          );
          t = t.filter(function (productId) {
            return productId !== e;
          });
          t.unshift(e);
          var maxItems = 20;
          t.length > maxItems && (t = t.slice(0, maxItems)),
            window.localStorage.setItem(
              theme.storageKeys.recentViewedProduct,
              JSON.stringify(t)
            );
        },
      });
  }

  // Auto-init: script defer roda após DOM parseado. Carrega só em template product.
  if (theme.product && theme.product.mainPage && typeof theme.product.mainPage.render === "function") {
    theme.product.mainPage.render();
  }
}
